<script>
import { PractitionerQualification, Coding } from '@/fhirworks';
import BnListBox from '@/components/BnListBox.vue';
import BnDialog from '@/components/BnDialog.vue';
import BnListSelectBox from '@/components/BnListSelectBox.vue';
import { addRefToBackBtnListiner, removeRefToBackBtnListiner } from '@/common/nativeBackButton';
import { useTerminologyList } from '@/composables/useTerminologyList';

export default {
    name: 'BnListQualifications',
    components: { BnListSelectBox, BnDialog, BnListBox },
    props: {
        modelValue: Array,
        viewOnly: Boolean,
    },
    emits: ['update:modelValue'],
    setup() {
        const { items: dpData } = useTerminologyList({ systems: ['http://code.system/practitioner.qualification'] }, { sort: 'display' });
        return { dpData };
    },
    data() {
        return {
            listBox: {
                title: 'Qualifications',
                icon: 'badge',
                addLabel: 'Add Qualification',
            },
            dialog: {
                title: 'Select Qualification',
            },
            itemsToAdd: [],
        };
    },
    computed: {
        computedDpData() {
            let items = this.dpData.map((item) => new Coding({ system: item.system, code: item.code, display: item.display }));
            return items.sort((a, b) => (a.display > b.display ? 1 : -1));
        },
        activeItems() {
            let items = this.modelValue.map((item, index) => {
                return { index: index, display: this.qualificationDisplay(item), code: item.code.codingZero?.code };
            });
            return items.sort((a, b) => (a.display > b.display ? 1 : -1));
        },
    },
    methods: {
        qualificationDisplay(item) {
            return item.code?.displayOrText || 'Qualification';
        },
        async addItemDialog() {
            if (this.viewOnly) return;
            const options = {
                header: false,
                width: 400,
                fullscreen: true,
            };
            addRefToBackBtnListiner(this.$refs.addItemDialog, 'close', 'addItemDialog');
            this.$refs.addItemDialog.show(options).then((save) => {
                removeRefToBackBtnListiner('addItemDialog');
                if (!save || this.viewOnly) return;
                const list = [...this.modelValue];
                this.itemsToAdd.forEach((item) => {
                    list.push(
                        new PractitionerQualification({
                            code: {
                                coding: [item],
                            },
                        }),
                    );
                });
                this.$emit('update:modelValue', list);
            });
        },
        removeItem(item) {
            if (this.viewOnly) return;
            const list = this.modelValue.filter((i, index) => index !== item.index);
            this.$emit('update:modelValue', list);
        },
    },
};
</script>

<template>
    <div>
        <BnListBox
            :title="listBox.title"
            :items="activeItems"
            item-text="display"
            :item-icon="listBox.icon"
            inactive
            :add="viewOnly ? false : listBox.addLabel"
            add-icon="plus"
            :remove="!viewOnly"
            :clickable="!viewOnly"
            :data-cy="$attrs['data-cy']"
            @add="addItemDialog"
            @remove="removeItem"
        />
        <BnDialog ref="addItemDialog">
            <BnListSelectBox
                v-model="itemsToAdd"
                title="Select Qualifications"
                :items="computedDpData"
                :added-items="activeItems"
                item-text="display"
                item-value="code"
                :item-icon="listBox.icon"
                multiple
                :dialog="{ title: 'Qualifications', save: 'Add' }"
                :data-cy="$attrs['data-cy']"
                @save="$refs.addItemDialog.confirm()"
                @cancel="$refs.addItemDialog.cancel()"
                @update:model-value="itemsToAdd = $event"
            />
        </BnDialog>
    </div>
</template>
